export default __webpack_public_path__ + "static/media/contentLogo.b10ccbca.svg";